export default [
    {
        id: 6995,
        name: '10º Pavimento - ED. Residencial',
        options: [
            {
                id: 5290,
                name: 'Apto 1001 - Banho Dormitório 01',
            },
            {
                id: 5294,
                name: 'Apto 1001 - Banho Dormitório 02',
            },
            {
                id: 5287,
                name: 'Apto 1001 - Circulação',
            },
            {
                id: 5289,
                name: 'Apto 1001 - Circulação 02',
            },
            {
                id: 5292,
                name: 'Apto 1001 - Circulação 03',
            },
            {
                id: 5284,
                name: 'Apto 1001 - Cozinha',
            },
            {
                id: 5285,
                name: 'Apto 1001 - Cozinha 02',
            },
            {
                id: 5291,
                name: 'Apto 1001 - Dormitório 01',
            },
            {
                id: 5293,
                name: 'Apto 1001 - Dormitório 02',
            },
            {
                id: 5288,
                name: 'Apto 1001 - Lavabo',
            },
            {
                id: 5283,
                name: 'Apto 1001 - Área Social',
            },
            {
                id: 5286,
                name: 'Apto 1001 - Área de Serviço',
            },
            {
                id: 5273,
                name: 'Apto 1002 - Banho Dormitório 01',
            },
            {
                id: 5275,
                name: 'Apto 1002 - Banho Dormitório 02',
            },
            {
                id: 5271,
                name: 'Apto 1002 - Circulação',
            },
            {
                id: 5277,
                name: 'Apto 1002 - Circulação 02',
            },
            {
                id: 5278,
                name: 'Apto 1002 - Cozinha',
            },
            {
                id: 5279,
                name: 'Apto 1002 - Cozinha 02',
            },
            {
                id: 5272,
                name: 'Apto 1002 - Dormitório 01',
            },
            {
                id: 5274,
                name: 'Apto 1002 - Dormitório 02',
            },
            {
                id: 5276,
                name: 'Apto 1002 - Lavabo',
            },
            {
                id: 5282,
                name: 'Apto 1002 - Área Social',
            },
            {
                id: 5280,
                name: 'Apto 1002 - Área de Serviço',
            },
            {
                id: 5269,
                name: 'Escada',
            },
            {
                id: 5270,
                name: 'Hall Serviço',
            },
            {
                id: 5281,
                name: 'Hall Social',
            },
            {
                id: 5268,
                name: 'Patamar Escada',
            },
            {
                id: 119124,
                name: 'Ponto 001',
            },
            {
                id: 102612,
                name: 'Ponto 004',
            },
        ],
    },
]
